{
  "appName": "Road Angel",
  "cmsDashboard": "Bridge Strike",
  "sidebar": {
    "signOut": "Sign Out",
    "devices": "Devices",
    "users": "Users",
    "logs": "Logs",
    "firmware": "Firmware",
    "settings": "Settings"
  },
  "common": {
    "actions": "Actions",
    "page": "Page",
    "currentFile": "Current File",
    "newFile": "New File",
    "chooseFile": "Choose File",
    "fileSelected": "File \"{{fileName}}\" selected successfully.",
    "fileTooLarge": "File is too large. Maximum size is {{maxSize}}.",
    "uploadEmpty": "Click to upload",
    "uploadNewFile": "Upload new file",
    "noData": "No data available",
    "error": "An error has occurred",
    "logMessages": {
      "LOW_BATTERY": "The device's battery is below the 20% threshold and is currently {{percentage}}%.",
      "MOVED": "The device has been moved from its set location {{latitude}}, {{longitude}}.",
      "NO_DATA": "The device did not report in at the regular time - {{expectedTime}}, last report was {{lastReport}}, Sync Interval is {{syncInterval}} days.",
      "TAMPER_DETECTION": "We have registered that the device has been opened without authorization. Take action if you did not do this!",
      "ACTIVE": "The device reported in at the regular time - {{time}}, Sync Interval is {{syncInterval}} days.",
      "INACTIVE": "The device is not activated and visible in the Bridge Strike device network."
    },
    "enums": {
      "logType": {
        "LOW_BATTERY": "Low Battery",
        "MOVED": "Moved",
        "NO_DATA": "No Data",
        "TAMPER_DETECTION": "Tamper Detection",
        "ACTIVE": "Active",
        "INACTIVE": "Inactive"
      },
      "deviceStatus": {
        "INACTIVE": "Inactive",
        "ACTIVE": "Active"
      },
      "userStatus": {
        "INACTIVE": "Inactive",
        "ACTIVE": "Active",
        "SUSPENDED": "Suspended",
        "TOTAL": "Total"
      },
      "logStatus": {
        "RESOLVED": "Resolved",
        "UNRESOLVED": "Unresolved"
      },
      "firmwareStatus": {
        "ACTIVE_DEPLOYMENT": "Active Deployment",
        "BETA": "Beta",
        "ALPHA": "Alpha"
      },
      "userRole": {
        "SUPER_ADMIN": "Super Admin",
        "ADMIN": "Admin",
        "USER": "User"
      },
      "dateType": {
        "single": "Single",
        "range": "Range"
      }
    },
    "tooltips": {
      "lowBattery": "Low Battery",
      "moved": "Moved",
      "noData": "No Data",
      "tamperDetection": "Tamper Detection"
    }
  },
  "confirmations": {
    "delete": "Delete this item?"
  },
  "buttons": {
    "no": "Cancel",
    "yes": "Confirm",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete"
  },
  "fileDownload": {
    "downloading": "Starting file download"
  }
}
